import { defineMessages } from "react-intl"

export const customerAddressListMessages = defineMessages({
	communicationAddress: {
		defaultMessage: "Communication address",
		id: "customerAddressList.communicationAddress",
	},
	homeAddress: {
		defaultMessage: "Home",
		id: "customerAddressList.homeAddress",
	},
	invoiceAddress: {
		defaultMessage: "Invoice address",
		id: "customerAddressList.invoiceAddress",
	},
	loadingError: {
		defaultMessage: "Oops, something went wrong loading the customer data.",
		id: "customerAddressList.loadingError",
	},
	workAddress: {
		defaultMessage: "Work",
		id: "customerAddressList.workAddress",
	},
})
